import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import HomeBanner1 from "../ones/HomeBanner1";

import Footer from "../ones/Footer";
import banner1 from '../assets/banner1.jpg';
import banner2 from '../assets/banner2.jpg';
import banner3 from '../assets/banner3.jpg';
import banner4 from '../assets/banner4.jpg';
import banner5 from '../assets/banner5.jpg';
import banner6 from '../assets/banner6.jpg';
import banner7 from '../assets/banner7.jpg';

import medical_pic from '../assets/photos/medical_equipments/18.jpg';
import promo_pic from '../assets/photos/promotional_materials/12.jpg';
import education_pic from '../assets/photos/educational_solutions/1.jpg';
import moble_pic from '../assets/photos/smart_mobile/2.jpg';
import realestate_pic from '../assets/photos/real_estate/3.jpg';
import telecom_pic from '../assets/photos/telecom_solutions/6.jpg';
import ict_pic from '../assets/photos/ict_solutions/1.jpg';
import agri_pic from '../assets/photos/agricultular_solutions/6.jpg';
import energ_pic from '../assets/photos/energy_solutions/1.jpg';
import green_pic from '../assets/photos/energy_solutions/3.jpg';

import sm1 from '../assets/photos/smart_mobile/1.jpg';
import sm2 from '../assets/photos/smart_mobile/2.jpg';
import sm3 from '../assets/photos/smart_mobile/3.jpg';
import sm4 from '../assets/photos/smart_mobile/4.jpg';
import sm5 from '../assets/photos/smart_mobile/5.jpg';
import sm6 from '../assets/photos/smart_mobile/6.jpg';
import sm7 from '../assets/photos/smart_mobile/7.jpg';



import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { FaArrowCircleRight } from "react-icons/fa";
import HorizontalImageStrip from "../ones/HorizontalImagesStrip";

export default function View(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);
	const [ bgIndex, setBgIndex ] = useState(0);
	const banners = [banner5, banner7, banner1, banner2, banner3, banner4, ];

	async function init() {
		//run initializations here
		setReady(false);
		//..
		
		setReady(true);
	}

	useEffect(() => {
		init();
	}, [ ])

	// Background transition effect
	useEffect(() => {
		if (!ready) return;

		const interval = setInterval(() => {
			setBgIndex(prev => (prev + 1) % banners.length);
		}, 2500); // change every 5 seconds

		return () => clearInterval(interval);
	}, [ready]);

	if(ready) {
		return (
			<>
				<div className="MainBodySection">
					<div
						style={{
							width: "100%",
							height: "auto",
							position: "relative",
							overflow: "hidden"
						}}
					>
						{banners.map((banner, i) => (
							<div
								key={i}
								style={{
									backgroundImage: `url(${banner})`,
									backgroundAttachment: "fixed",
									backgroundSize: "cover",
									backgroundPosition: "center",
									width: "100%",
									height: "100%",
									position: "absolute",
									top: 0,
									left: 0,
									transition: "opacity 1.5s ease-in-out",
									opacity: i === bgIndex ? 1 : 0,
								}}
							/>
						))}
	
						{/* gradient overlay */}
						<div
							style={{
								width: "100%",
								height: "100%",
								background: "linear-gradient(to right, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.4) 80%, rgba(0,0,0,0) 100%)",
								position: "relative",
								zIndex: 1
							}}
						>
							<div className="container">
								<div className="row">
									<div className="col-md-6">
										<h1
											className="font-bold text-light"
											style={{
												fontSize: "28px",
												paddingTop: "40px",
												paddingBottom: "40px",
												textTransform: "uppercase",
											}}
										>
											SMART MOBILE DEVICES AND SOLUTIONS
										</h1>
	
										
	
									</div>
	
									
	
								</div>
							</div>
						</div>
	
					</div>
				</div>
				
				<div 
					className="MainBodySection"
					style={{
						paddingBottom: "50px",
						paddingTop: "50px"
					}}
				>
					<div className="container">
						<div className="row">

							<div className="col-md-12">
								<img
									src={moble_pic}
									style={{
										width: "100%"
									}}
								/>
								<h6
									style={{
										fontSize: "18px",
										marginTop: "20px",
										marginBottom: "20px",
									}}
								>
									At JIEZHI TECH CO LTD, we offer a comprehensive range of smart mobile devices and solutions designed to cater to the complex and evolving needs of various industries.
								</h6>

								<HorizontalImageStrip
									images={[sm1, sm2, sm3, sm4]}
								/>
							</div>

							<div className="col-md-6 mt-3 mb-4">
								<h6
									className="main-section-title"
								>
									SMART PAYMENT DEVICES
								</h6>

								<img
									style={{
										width: "100%",
										height: "auto",
										display: "block",
									}}
									src={sm6}
								/>	

								<h6
									style={{
										fontSize: "16px",
										borderLeft: "10px solid var(--primaryColor)",
										paddingLeft: "10px"
									}}
								>
									We provide advanced payment solutions that facilitate secure and efficient transactions across multiple sectors.
								</h6>
							</div>

							<div className="col-md-6 mt-3 mb-4">
								<h6
									className="main-section-title"
								>
									SMART RETAIL DEVICES
								</h6>

								<img
									style={{
										width: "100%",
										height: "auto",
										display: "block",
									}}
									src={sm5}
								/>	

								<h6
									style={{
										fontSize: "16px",
										borderLeft: "10px solid var(--primaryColor)",
										paddingLeft: "10px"
									}}
								>
									Our smart retail devices are designed to enhance the shopping experience, streamline operations, and improve overall efficiency in the retail industry.
								</h6>
							</div>

							<div className="col-md-6 mt-3 mb-4">
								<h6
									className="main-section-title"
								>
									SMART SECURITY DEVICES
								</h6>

								<img
									style={{
										width: "100%",
										height: "auto",
										display: "block",
									}}
									src={sm1}
								/>	

								<h6
									style={{
										fontSize: "16px",
										borderLeft: "10px solid var(--primaryColor)",
										paddingLeft: "10px"
									}}
								>
									We offer cutting-edge security devices that ensure the safety and protection of assets, data, and personnel across various settings.
								</h6>
							</div>

							<div className="col-md-6 mt-3 mb-4">
								<h6
									className="main-section-title"
								>
									SMART TRANSPORTATION DEVICES
								</h6>

								<img
									style={{
										width: "100%",
										height: "auto",
										display: "block",
									}}
									src={sm3}
								/>	

								<h6
									style={{
										fontSize: "16px",
										borderLeft: "10px solid var(--primaryColor)",
										paddingLeft: "10px"
									}}
								>
									Our smart transportation devices are built to optimize logistics, fleet management, and supply chain operations, enabling seamless connectivity and real-time monitoring.
								</h6>
							</div>

							<div className="col-md-6 mt-3 mb-4">
								<h6
									className="main-section-title"
								>
									SMART RUGGED TABLETS
								</h6>

								<img
									style={{
										width: "100%",
										height: "auto",
										display: "block",
									}}
									src={sm4}
								/>	

								<h6
									style={{
										fontSize: "16px",
										borderLeft: "10px solid var(--primaryColor)",
										paddingLeft: "10px"
									}}
								>
									We provide durable and reliable rugged tablets that can withstand harsh environments and demanding conditions, making them ideal for use in industries such as transportation, construction, and field services.
								</h6>
							</div>

							
	
						</div>
					</div>
				</div>

				<Footer/>
			</>
		)
	} else {
		return (
			<div 
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}

	
}